import { render, staticRenderFns } from "./TheSettingsAccount.vue?vue&type=template&id=bbd505e8&scoped=true&"
import script from "./TheSettingsAccount.vue?vue&type=script&lang=js&"
export * from "./TheSettingsAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd505e8",
  null
  
)

export default component.exports